module.exports = __webpack_public_path__ + "static/story-2-59ffd6b8e845df0bd7e9fd6ae8ddc4c8.png";